import { Injectable, ErrorHandler } from '@angular/core';
import { AnalyticsHelper } from '../shared/analytics/analytics-helper';

export const ERROR_KEY = 'unhandled-error';

// our global error handler
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private readonly analytics: AnalyticsHelper) { }

  handleError(error: Error) {
    try {
      this.analytics.logError(error, ERROR_KEY);
    } finally {
      console.trace('uncaught error:', error);
    }
  }
}
